// extracted by mini-css-extract-plugin
module.exports = {"container":"FaxManagementHeaderStyles_container__1UHha","link":"FaxManagementHeaderStyles_link__3oicD","selected":"FaxManagementHeaderStyles_selected__2cCH6"};